function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.023 11h14.123v2H4.023z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.444 3.5l8.485 8.485-1.414 1.414-8.485-8.485z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.93 11.986l-8.486 8.485-1.414-1.414 8.486-8.485z"
});

var SvgArrow = function SvgArrow(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _ref, _ref2, _ref3);
};

export default SvgArrow;